// Added by Jonghyung Lee on 2020-11-04
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { makeAutoObservable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Root Store
import RootStore from '../../index'

// Service
import { reqGetWPSWorks, reqGetWPSWork, reqUpdateWPSWorks, reqCancelWPSWorks, reqDeleteWPSWorks } from '@/service/wps.service'

import { WPSWorks } from '@/helper/define/wpsDefine'
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class WPSStore {
  _elements: WPSWorks[] = []

  root?: RootStore

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(root: RootStore) {
    this.root = root
    makeAutoObservable(this)
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getElements = async (path?: string) => {
    const {
      data: { items: wpsElements, total_count },
    } = await reqGetWPSWorks(path)
    this._elements = wpsElements!
    return { wpsWorks: this._elements, totalCnt: total_count }
  }

  getElement = async (id: string) => {
    return await reqGetWPSWork(id)
  }

  updateElement = async (id: string, element: WPSWorks) => {
    return await reqUpdateWPSWorks(id, element)
  }

  deleteElement = async (id: string) => {
    return await reqDeleteWPSWorks(id)
  }

  cancelElement = async (id: string) => {
    await reqCancelWPSWorks(id)
    const {
      data: { items: wpsElements },
    } = await reqGetWPSWorks()
    this._elements = wpsElements!
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  setElements = (elements: WPSWorks[]) => {
    this._elements = elements
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  get wps() {
    return this._elements
  }
}
